<template>
  <div class="qv__images">
    <div class="qv__images-wrapper">
      <div v-for="(image,index) in carouselImages" :key="index" class="qv__images-slide">
        <span class="qv__images-count">{{index+1}}/{{carouselImages.length}}</span>
        <ImageField :key="image.src" class="qv__image" :obj="{'url':image.src,'alt':image.alt,'width':'2000','height':'2000'}" width-param="width" sizes="2000px"/>
      </div>
    </div>
    <div class="qv__nav qv__prev">
      <svg class="qv__prev-icon">
        <use xlink:href="#icon-prev"></use>
      </svg>
    </div>
    <div class="qv__nav qv__next">
      <svg class="qv__next-icon">
        <use xlink:href="#icon-next"></use>
      </svg>
    </div>

    <WishlistCTA
      v-if="showWishlistIcon"
      :product="product"
      :selectedVariantDetails="productForm"
      :firstOptionName="firstOption"
      customClass="quick-view_wishlisticon"
    />
  </div>
</template>

<script setup>
  import { computed, toRefs, ref, onMounted, onUpdated } from 'vue';
  import ImageField from '../global/image.vue';
  import Swiper from 'swiper';
  import SwiperCore, { Navigation, A11y } from 'swiper/core';
  import WishlistCTA from '../global/wishlist-cta.vue';

  SwiperCore.use([Navigation, A11y]);

  const props = defineProps({
    product: {
      type: Object,
      default: () => ({})
    },

    selectedColor: {
      type: String,
      default: ''
    },

    selectedTown: {
      type: String,
      default: null
    },

    productForm: {
      type: Object,
      default: ''
    },

    firstOption: {
      type: String,
      default: ''
    },

    showWishlistIcon : {
      type: Boolean,
      default: true
    }
  })

  const { product,selectedColor,selectedTown } = toRefs(props);

  onMounted(() =>{
    gallerySwiper.value = new Swiper('.qv__images', galleryCarousel.value)

    window.addEventListener('resize', () => {
      windowWidth.value = window.innerWidth
    })
  })

  onUpdated(() => {
    setTimeout(()=>{
      gallerySwiper.value.destroy()
      gallerySwiper.value = new Swiper('.qv__images', galleryCarousel.value)
    },100)
  })

  var gallerySwiper = ref(null);
  var windowWidth = ref(window.innerWidth);

const galleryCarousel = computed(() => {
  return {
    slidesPerView: 1,
    spaceBetween: 0,
    wrapperClass: 'qv__images-wrapper',
    slideClass: 'qv__images-slide',
    watchOverflow: true,
    navigation: {
      nextEl: '.qv__next',
      prevEl: '.qv__prev',
    },
    a11y: {
      enabled: true
    }
  }
})

  const carouselImages = computed(() => {
    const {images,title} = product.value;

    const imageData = window.getProductImages(images,selectedColor.value,title,selectedTown.value);
    return imageData;   
  })
</script>